var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useNotification } from "@/components/Notify/useNotification";
import { useImageResize } from "@/workers/useImageResize";
import { FileUploadPreview } from "./FileUploadPreview";
import { changeExtension } from "./tools";
var addedFilesMapper = function (file) {
    var previewUrl = undefined;
    if (file.type.startsWith("image/")) {
        previewUrl = URL.createObjectURL(file);
    }
    return {
        id: crypto.randomUUID(),
        name: file.name,
        size: file.size,
        type: file.type,
        file: file,
        url: previewUrl,
        status: "added",
        isResized: false,
    };
};
/** Используется только для картинок,
 * поэтому их обработка и ресайз сразу включены */
export var FileUpload = function (props) {
    var showError = useNotification().showError;
    var maxFiles = props.maxFiles || 10;
    var accept = "image/*";
    var fileInputRef = useRef(null);
    // Список файлов
    var _a = useState(function () {
        var _a;
        return (((_a = props.initialFiles) === null || _a === void 0 ? void 0 : _a.map(function (f) { return (__assign(__assign({}, f), { status: "uploaded" })); })) || []);
    }), files = _a[0], setFiles = _a[1];
    // Активные файлы
    var activeFiles = files.filter(function (el) { return el.status !== "deleted"; });
    // Передача изменений наружу
    useEffect(function () {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, files);
        return function () {
            // Очистка objectURL при изменении/уходе
            files.forEach(function (f) {
                if (f.url.startsWith("blob:")) {
                    URL.revokeObjectURL(f.url);
                }
            });
        };
    }, [files]);
    var processImage = useImageResize().processImage;
    useEffect(function () {
        // подмена файлов после ресайза
        var runWorker = function (file) { return __awaiter(void 0, void 0, void 0, function () {
            var resizedFile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (files.length === 0)
                            return [2 /*return*/];
                        return [4 /*yield*/, processImage({
                                sourceFile: file,
                                outputWidth: props.imageWidth,
                                outputHeight: props.imageHeight,
                            })];
                    case 1:
                        resizedFile = _a.sent();
                        return [2 /*return*/, resizedFile];
                }
            });
        }); };
        // второй раз запуститься не должно, т.к. после воркера меняем isResized
        var unresizedFiles = files.filter(function (f) { return !!("file" in f && !!f.file) && !f.isResized; });
        // через воркер прогоняем о одному файлу
        if (unresizedFiles.length) {
            var processingFile_1 = unresizedFiles[0];
            runWorker(processingFile_1.file)
                .then(function (workerMessage) {
                // Собираем файл после воркера
                var blob = new Blob([workerMessage.buffer], {
                    type: workerMessage.mimeType,
                });
                // т.к. воркер нам принудительно делает jpg, меняем расширение для аплоада
                var fileName = changeExtension(processingFile_1.name, "jpg");
                var resultFile = new File([blob], fileName, {
                    type: workerMessage.mimeType,
                    lastModified: Date.now(),
                });
                setFiles(function (prev) {
                    return prev.map(function (stateFile) {
                        if (processingFile_1.id === stateFile.id &&
                            !processingFile_1.isResized) {
                            return __assign(__assign({}, stateFile), { file: resultFile, url: URL.createObjectURL(resultFile), isResized: true });
                        }
                        else {
                            return stateFile;
                        }
                    });
                });
            })
                .catch(console.error);
        }
    }, [files]);
    // Окно выбора файлов
    var handleFileSelect = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    // Обработка выбора файлов
    var handleFileChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var fileList, newFiles_1;
        return __generator(this, function (_a) {
            fileList = Array.from(event.target.files || []);
            if (activeFiles.length >= maxFiles) {
                showError({ message: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C ".concat(maxFiles, " \u0444\u0430\u0439\u043B\u043E\u0432") });
                return [2 /*return*/];
            }
            // Сначала забиваем файлами из инпута
            if (maxFiles === 1 || !props.multiple) {
                setFiles([addedFilesMapper(fileList[0])]);
            }
            else {
                newFiles_1 = fileList
                    .slice(0, maxFiles - files.length)
                    .map(addedFilesMapper);
                setFiles(function (prev) { return __spreadArray(__spreadArray([], prev, true), newFiles_1, true); });
            }
            if (event.target)
                event.target.value = "";
            return [2 /*return*/];
        });
    }); };
    // Обработка удаления файлов
    var removeFile = function (id) {
        // Свежедобавленные файлы удаляем сразу,
        // загруженные ранее - метим статусом
        setFiles(function (prev) {
            return prev
                .map(function (f) {
                return f.id === id
                    ? f.status === "added"
                        ? null
                        : __assign(__assign({}, f), { status: f.status === "deleted" ? "uploaded" : "deleted" })
                    : f;
            })
                .filter(function (f) { return f !== null; });
        });
    };
    var restoreFile = function (id) {
        setFiles(function (prev) {
            return prev.map(function (f) { return (f.id === id ? __assign(__assign({}, f), { status: "uploaded" }) : f); });
        });
    };
    return (_jsxs("div", { children: [_jsx("input", { ref: fileInputRef, type: "file", multiple: props.multiple, accept: accept, onChange: handleFileChange, style: { display: "none" } }), _jsx(FileUploadPreview, { files: files, onRemove: removeFile, onRestore: restoreFile, onAdd: (activeFiles.length < maxFiles && props.multiple) ||
                    (!props.multiple && !activeFiles.length)
                    ? handleFileSelect
                    : undefined })] }));
};
